export const StoreState = {
  accepting: '注文受付中',
  pending: '注文停止中',
  unavailable: '利用不可',
} as const;
export type StoreState = keyof typeof StoreState;
